import axiosInstance from './AxiosInstance';

class DevicesManagementService {
    constructor() {
        this.endpoint = "/api/devices"
    }

    async getDevices(params) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}`, {
                params
            });

            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    async getLatestSyncinformationByID(componentID) {
        try {
            const response = await axiosInstance.get(`${this.endpoint}/${componentID}/syncinformation/latest`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
}

const devicesManagementService = new DevicesManagementService();

export { devicesManagementService };